<script setup>
defineProps({
  channel: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <section
    class="flex items-center rounded-lg shadow bg-cover mb-2 py-1 willy:rounded-none"
    :style="{ backgroundImage: `url(${channel.station.logo.site_background})`, color: channel.color.extra }"
  >
    <img class="ml-2 h-14" :src="channel.station.logo.site_logo" alt="" aria-hidden="true" />
    <h1 class="text-2xl m-0 w-full border-box absolute text-center leading-none font-semibold">
      {{ channel.station.name }}
    </h1>
  </section>
</template>
